import { Injectable } from '@angular/core';
import { BaseService } from '@core/service/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CommodityInformationService extends BaseService{

  constructor(http: HttpClient) {
    super(http);
  }
  private url = 'api/commodity-information';
  getUrl(): string {
    return this.url;
  }

  //  批量删除订单明细
  orderDetailBatchDelete(ids:any[]):Observable<any> {
    return this.http.post<any>(this.getUrl(),ids).pipe(
      tap(_ => this.log(`deleted object list id=${ids}`)),
      catchError(this.handleError<any>('delet object list'))
    );
  }
}
